module.exports = __webpack_public_path__ + "img/km.6d074963.svg";